// KAN-830 PR 10 (KAN-736 R24, D33) — the campaign routes, registered only
// while the campaign-surface flag is on (codex r1 on PR 1393). With the flag off
// /campaigns and /campaigns/:id match nothing, exactly as before KAN-736.

import { Route } from 'react-router-dom'
import { campaignsSurfaceEnabled } from '@/lib/campaigns-surface'
import { CampaignsPage } from '@/pages/CampaignsPage'
import { CampaignDetailPage } from '@/pages/CampaignDetailPage'

export function campaignRoutes() {
  if (!campaignsSurfaceEnabled()) return null
  return (
    <>
      <Route path="campaigns" element={<CampaignsPage />} />
      <Route path="campaigns/:id" element={<CampaignDetailPage />} />
    </>
  )
}
